import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import {
  UsageSummaryResponseSchema,
  UsageSavingsResponseSchema,
} from "@/api/schemas";
import type { TimeRange } from "@/components/TimeRangeSelector";

export function useUsageSummary(
  tenantId: string,
  range: TimeRange,
  groupBy: "day" | "feature" | "user",
  userId = "",
) {
  return useQuery({
    queryKey: ["usage-summary", tenantId, range.from, range.to, groupBy, userId],
    queryFn: async () => {
      const searchParams: Record<string, string> = {
        from: range.from,
        to: range.to,
        group_by: groupBy,
      };
      if (userId) searchParams.user_id = userId;
      const json = await api.get("usage/summary", { searchParams }).json();
      return UsageSummaryResponseSchema.parse(json);
    },
    enabled: !!tenantId,
  });
}

export function useUsageSavings(tenantId: string, range: TimeRange, userId = "") {
  return useQuery({
    queryKey: ["usage-savings", tenantId, range.from, range.to, userId],
    queryFn: async () => {
      const searchParams: Record<string, string> = {
        from: range.from,
        to: range.to,
      };
      if (userId) searchParams.user_id = userId;
      const json = await api.get("usage/savings", { searchParams }).json();
      return UsageSavingsResponseSchema.parse(json);
    },
    enabled: !!tenantId,
  });
}
